import { motion } from "framer-motion";
import { WA_LINK } from "../site";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const Header = () => (
  <motion.header
    initial={{ y: -80, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
    className="fixed top-0 left-0 right-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10"
    data-testid="site-header"
  >
    <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
      <a href="#top" data-testid="header-logo" className="font-serif text-xl md:text-2xl tracking-tight text-stone-100">
        Relax <span className="italic text-gold-400">Massage Spa</span>
      </a>
      <nav className="hidden md:flex items-center gap-8 text-sm tracking-wide text-stone-300">
        <a href="#services" data-testid="nav-services" className="hover:text-gold-400 transition-colors duration-300">Services</a>
        <a href="#about" data-testid="nav-about" className="hover:text-gold-400 transition-colors duration-300">About</a>
        <a href="#gallery" data-testid="nav-gallery" className="hover:text-gold-400 transition-colors duration-300">Gallery</a>
        <a href="#visit" data-testid="nav-visit" className="hover:text-gold-400 transition-colors duration-300">Visit</a>
      </nav>
      <a
        href={WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="header-book-button"
        className="group inline-flex items-center gap-2 rounded-full bg-[#128C4A] hover:bg-[#16a35a] px-4 py-2 md:px-6 md:py-2.5 text-xs md:text-sm font-semibold tracking-wide text-white transition-colors duration-300"
      >
        <WhatsAppIcon className="w-4 h-4" />
        <span className="hidden sm:inline">Book via WhatsApp</span>
        <span className="sm:hidden">Book</span>
      </a>
    </div>
  </motion.header>
);
